import { useState } from 'react';
import { useGetProductsQuery } from '../products/products.api';
import { IEvent, ProductScope } from '@topshots/core-models';
import { Pager } from '../pager/pager';
import { ProductsTable } from '../products/products-table';
import { Label } from 'shared-components';
import { CardContent } from 'shared-components';
import { Types } from 'mongoose';
import { useFormikContext } from 'formik';

export const EventProducts = () => {
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [search] = useState<string | undefined>(undefined);
  const { setFieldValue, values } = useFormikContext<Partial<IEvent>>();
  const { data } = useGetProductsQuery({
    page,
    perPage,
    search,
    includeArchived: false,
    includeUnconfirmed: false,
    scope: ProductScope.Event,
  });

  return (
    <>
      <CardContent>
        <Label htmlFor="">Enabled Products</Label>
      </CardContent>
      <ProductsTable
        data={(data?.data ?? []).filter((p) =>
          (values.enabledProducts as Types.ObjectId[]).includes(p._id)
        )}
        action={{
          title: 'Disable',
          handler: (product) => {
            setFieldValue(
              'enabledProducts',
              (values.enabledProducts as Types.ObjectId[]).filter(
                (p) => p.toString() !== product._id.toString()
              )
            );
          },
        }}
      />
      <CardContent>
        <Label htmlFor="">Available Products</Label>
      </CardContent>
      <ProductsTable
        data={(data?.data ?? []).filter(
          (p) => !(values.enabledProducts as Types.ObjectId[]).includes(p._id)
        )}
        action={{
          title: 'Enable',
          handler: (product) => {
            setFieldValue(
              'enabledProducts',
              (values.enabledProducts as Types.ObjectId[]).concat(product._id)
            );
          },
        }}
      />
      <Pager
        onNext={() => {
          setPage(page + 1);
        }}
        onPrevious={() => {
          setPage(page - 1);
        }}
        onPageSelected={(selected) => {
          setPage(selected);
        }}
        onPerPageChange={(selected) => {
          setPerPage(selected);
          setPage(1);
        }}
        page={page}
        perPage={perPage}
        totalPages={data?.totalPages ?? 1}
      />
    </>
  );
};
